import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ProductEnhancementDocument.ListDealerGroupDocuments.IRequest;
type Response = Api.Core.ProductEnhancementDocument.ListDealerGroupDocuments.IResponse;
type Headers = Api.Core.ProductEnhancementDocument.ListDealerGroupDocuments.IHeaders;
const url = '/api/ProductManagement/ProductEnhancementDocument/GetDealerGroupDocuments';
export default async function productEnhancementDocumentListDealerGroupDocumentsApi(
  body?: Request
): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(url),
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
